import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';
import { AuthService } from './auth.service';

interface Form {
    id: string
}


@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    private _form: Form = { id: '' };
    base_uri: any='https://stgmformadminapi.dhwaniris.in/api/admin/v1/';

    public getForm(): Form {
        return this._form;
    }

    public setFormId(value: string) {
        this._form.id = value;
    }
    projectId: string = sessionStorage.getItem('projectId');
    organisationId: string = sessionStorage.getItem('organisationId');
    token = sessionStorage.getItem('token');

    constructor(private httpClient: HttpClient, private http: Http, private router: Router, private auth: AuthService,
        @Inject('env') private env
        ) {
        this.base_uri = env.base_uri
    }

    getFormStringDetails() {
        return this.httpClient.get(`${this.base_uri}translationGet/get/${this._form.id}`, this.auth.setHttpHeaders())
            .map((response: any) => response)
            .catch(this.handleError).toPromise();
    }

    updateQuestionText(questionObj, id, lng) {
        return this.httpClient.put(`${this.base_uri}/translationPut-By-Order/put/${id}?language=${lng}&order=${questionObj.order}`, JSON.stringify(questionObj), this.auth.setHttpHeaders())
            .map((response: any) => response)
            .catch(this.handleError).toPromise();
    }

    getFormDetails() {
        return this.httpClient.get(`${this.base_uri}`);

    }

    getLanguages(formId = '') {
        formId = formId ? formId : this._form.id;
        return this.httpClient
            .get(`${this.base_uri}language?_formId=${formId}`, this.auth.setHttpHeaders())
            .map((response: any) => response)
            .toPromise();
    }

    updateLanguages(_id, body) {
        return this.httpClient.post(`${this.base_uri}translationPost/post/${_id}`, JSON.stringify(body), this.auth.setHttpHeaders())
            .map((response: any) => response)
            .toPromise();
    }

    getPublishedQuestionText(form_id, languageCode, order) {
        return this.httpClient.get(`${this.base_uri}translationGet-By-Order/get/${form_id}?language=${languageCode}&order=${order}`, this.auth.setHttpHeaders())
            .map((response: any) => response)
            .toPromise();
    }

    handleError(error: Response) {
        return throwError(error || 'SERVER ERROR');
    }

    getTranslationFormat(temp_formId = '') {
        return `${this.base_uri}translation-download-excel/${temp_formId}?organisation=${this.organisationId}&project=${this.projectId}&token=${sessionStorage.getItem('token')}`;
    }

    uploadTranslationData(temp_formId = '', file) {
        return this.httpClient.post(`${this.base_uri}translation-bulk-upload/${temp_formId}`, file, this.auth.setHttpHeadersFormData())
            .map((response: any) => response)
            .toPromise();
    }
}
